module.exports = __webpack_public_path__ + "img/total_installed_capacity_per_year_exgeo.643a974f.png";